module.exports = __webpack_public_path__ + "media/assets/icons/card-mail-f81abb0f1b52cb57297857186a13cdce.svg";